export const CREDIT_BALANCE_INFORMATION_MODAL =
  'credit-balance-information-modal'
